import { Box, Typography } from "@mui/material";
import colors from "../../../../shared/constants/color";
import {
  getAiScoreCircleSx,
  aiScoreSvgStyle,
  getAiScoreTextSx,
} from "../../style";

interface AIScoreCircleProps {
    score: number;
    size?: number;
    uniqueId?: string;
    centerText?: string;
}

export const AIScoreCircle = ({
    score,
    size = 30,
    uniqueId = "default",
    centerText,
}: AIScoreCircleProps) => {
    const radius = size / 2 - 2; // strokeWidth için 2px boşluk
    const circumference = 2 * Math.PI * radius;
    const strokeDashoffset = circumference * (1 - score / 100);

    return (
        <Box sx={getAiScoreCircleSx(size)}>
            <svg
                width={size}
                height={size}
                style={aiScoreSvgStyle}
            >
                {/* Background circle */}
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke={colors.neutral.N30}
                    strokeWidth="2"
                />
                {/* Progress circle */}
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke={`url(#gradient-${uniqueId})`}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeDasharray={circumference}
                    strokeDashoffset={strokeDashoffset}
                />
                <defs>
                    <linearGradient id={`gradient-${uniqueId}`} x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="5.62%" stopColor={colors.aiGradientStart} />
                        <stop offset="95.62%" stopColor={colors.aiGradientEnd} />
                    </linearGradient>
                </defs>
            </svg>
            <Typography sx={getAiScoreTextSx(size)}>
                {centerText ?? score}
            </Typography>
        </Box>
    );
};

